// extracted by mini-css-extract-plugin
var _1 = "ProfileFinishedWidget-modulecontent__cDNu2";
var _2 = "ProfileFinishedWidget-moduleskeleton__J5rLi WidgetContentSkeleton-moduleWidgetContentSkeleton__eblVC";
export { _1 as "content", _2 as "skeleton" }
